import React, { Component } from 'react'
import { conditionalWidth } from '../../../utils/useful'
import Responsive from '../../Responsive'
// import Slider from '../../slider/Slider'
import SliderSingle from '../../slider/SliderSingle'




export default class Related extends Component {
    state = {
        info: [
            { title: "Offered by", des: "zoom.us" },
            { title: "Version", des: "1.8.13" },
            { title: "Updated", des: "March 6, 2023" },
            { title: "Size", des: "235KiB" },
            { title: "Languages", des: "English, French, Spanish" },
            { title: "Developer", des: "This developer has identified itself as a trader per the definition from the European Union." },

        ],

        reviews: [
            { img: "/images/p2.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p3.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p4.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p5.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p6.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p7.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p8.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
        ],

        items: [
            { icon: "/images/p1.png", title: 'Survivor!.io', des: "Survive the fun!" },
            { icon: "/images/p2.png", title: 'Subway Surfers', des: "Join the endless running fun!" },
            { icon: "/images/p3.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p4.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p5.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p6.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p7.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p8.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p1.png", title: 'Survivor!.io', des: "Survive the fun!" },
            { icon: "/images/p2.png", title: 'Subway Surfers', des: "Join the endless running fun!" },
            { icon: "/images/p3.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p4.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            { icon: "/images/p5.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
            { icon: "/images/p6.png", title: 'Dumb Way to Die', des: "Safety First" },
            { icon: "/images/p7.png", title: 'CSR 2 Drag Racing Car Games', des: "Racing Games Driving Simulator" },
            // { icon: "/images/p8.png", title: 'Pivote Table', des: "Build visualization using Vega-Lite" },
        ],
    }

    render() {
        return (
            <div className='w-100'>
                <div className='d-flex' style={{ backgroundColor: "#fff" }}>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", }}>
                        <div className='p-4'>
                            <div className='d-flex flex-wrap pt-2 px-4'>
                                {this.state.items.map((prop, index) => {
                                    return (
                                        <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", lg: "4" }}>
                                            <div className={'flexcb p-1 my-1 br-10 cursor-pointer ' + (index % conditionalWidth(this.props.width, { xs: ' 0 ', lg: ' 3 ' }) == 0 ? "mrd-2" : "mld-2")} style={{ backgroundColor: "#f6f6f6", border: "1px solid #f5f5f5" }} onClick={() => this.openSingle()}>
                                                <div className='flexc'>
                                                    <img className='br-5' width={50} src={prop.icon} />
                                                    <div className='mld-3'>
                                                        <p className='font-size-14' style={{ color: "#333" }}>{prop.title}</p>
                                                        <p className='font-size-10' style={{ color: "#888" }}>{prop.des}</p>
                                                    </div>
                                                </div>
                                                <button className='px-3 br-5 py-2 mrd-3' style={{ backgroundColor: "#eee" }}>
                                                    <p className='font-size-12' style={{ color: "#0073ee" }}>Add</p>
                                                </button>
                                            </div>
                                        </Responsive>
                                    )
                                })}
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
